export const findClosestCity = async (input, country, language) => {
    let resp = await fetch("/api/findcity?" + new URLSearchParams({
        value: input,
        country,
        lang: language,
    })).catch(e => console.log(e))

    let error = null
    let body = await resp
        .json()
        .catch(e => error = "something_went_wrong");

    if(error) {
        return {
            ok: false,
            err: error
        }
    }
    
    if(!body) {
        return {
            "ok": false,
            "err": "something_went_wrong",
        }
    }

    return {
        "ok": true,
        "cities": body.output,
    }
}